import axiosInstance from "auth/FetchInterceptor";
import { FINANCE_MUA_BAN_HANG_API } from "constants/ApiConstant";
const FinanceMuaBanHangService = {};

FinanceMuaBanHangService.GetAllFinanceMuaBanHang = function (data) {
  return axiosInstance.post(
    `${FINANCE_MUA_BAN_HANG_API}/get-all-danh-sach`,
    data,
    {
      baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
    }
  );
};

FinanceMuaBanHangService.GetFinanceMuaBanHangId = function (data) {
  return axiosInstance.get(
    `${FINANCE_MUA_BAN_HANG_API}/get-finance-muabanhang-id?id=${data.id}`,
    {
      baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
    }
  );
};

FinanceMuaBanHangService.UpsertFinanceMuaBanHang = function (data) {
  return axiosInstance.put(
    `${FINANCE_MUA_BAN_HANG_API}/upsert-finance-muabanhang`,
    data,
    {
      baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
    }
  );
};
FinanceMuaBanHangService.DeleteFinanceMuaBanHang = function (id) {
  return axiosInstance.delete(
    `${FINANCE_MUA_BAN_HANG_API}/delete-finance-muabanhang?id=${id}`,
    {
      baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
    }
  );
};

///Chi tiết
FinanceMuaBanHangService.GetFinanceDSChiTietMuaBanHang = function (data) {
  return axiosInstance.get(
    `${FINANCE_MUA_BAN_HANG_API}/get-finance-muabanhang-chitiet-id?id=${data.id}`,
    {
      baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
    }
  );
};
FinanceMuaBanHangService.UpsertFinanceMuaBanHangChiTiet = function (data) {
  return axiosInstance.put(
    `${FINANCE_MUA_BAN_HANG_API}/upsert-finance-muabanhang-chitiet`,
    data,
    {
      baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
    }
  );
};
FinanceMuaBanHangService.DeleteFinanceMuaBanHangChiTiet = function (id) {
  return axiosInstance.delete(
    `${FINANCE_MUA_BAN_HANG_API}/delete-finance-muabanhang-chitiet?id=${id}`,
    {
      baseURL: process.env.REACT_APP_SALE_ENDPOINT_URL,
    }
  );
};
export default FinanceMuaBanHangService;
